(() => {
	'use strict';

	const siteMapHeight = () => {
		const dataAttrPref = 'data-get-height';
		const wrap = document.querySelector(`[${dataAttrPref}-wrap]`);
		if (!wrap) return;
		const items = wrap.querySelectorAll(`[${dataAttrPref}-item]`);
		if (!items.length) return;

		// CSSのgap値を取得
		const style = window.getComputedStyle(wrap); // CSSのスタイルを取得
		const gap = parseFloat(style.getPropertyValue('gap').split(' ')[0]) || 40; // gapがNaNの場合0をデフォルトに

		let totalHeightWithGap = 0; // gapを含めたアイテムの高さの合計
		const itemHeights = Array.from(items).map(item => item.offsetHeight);

		// 各アイテムの高さを計算
		itemHeights.forEach((height, index) => {
			totalHeightWithGap += height;
			if (index < itemHeights.length - 1) {
				totalHeightWithGap += gap; // 最後のアイテム以外のgapを追加
			}
		});

		// 2カラムの高さを計算
		const calculatedHeight = totalHeightWithGap / 2;

		// CSS変数に設定
		document.documentElement.style.setProperty('--siteMap-height', `${calculatedHeight}px`);
	};

	document.addEventListener('DOMContentLoaded', siteMapHeight);
})();
